var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-page',{attrs:{"title":"Connect!"}},[_c('core-connect-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }